import React, { useState, useEffect } from 'react';
import './App.css';
import Landingpage from './pages/elements/landingpage';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import NotFound from './pages/NotFound';
import Login from './pages/login';

function App() {

  // keep userId in localStorage so multiple tabs stay logged in
  const [userId, setUserId] = useState(() => {
    return localStorage.getItem('userId') || "";
  });

  // any time the userId changes update storage
  React.useEffect(() => {
    if (userId) {
      localStorage.setItem('userId', userId);
    } else {
      localStorage.removeItem('userId');
    }
  }, [userId]);

  return (
    <BrowserRouter>

      <Routes>

        {/* Login page */}
        <Route
          path="/login"
          element={
            userId ? (
              <Navigate to="/" />
            ) : (
              <Login setUserId1={(userId1) => setUserId(userId1)} />
            )
          }
        />

        {/* Protected routes */}
        <Route
          path="/*"
          element={
            userId
              ? <Landingpage userId1={userId} logout={() => setUserId("")} />
              : <Navigate to="/login" />
          }
        />

        {/* 404 page */}
        {/* <Route path="*" element={<NotFound />} /> */}

      </Routes>

    </BrowserRouter>
  )
}

export default App